import React, { useState, useEffect } from "react";
import { FaInstagram, FaFacebook, FaLinkedin } from "react-icons/fa";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
import { Helmet } from "react-helmet";
//import logo2 from "../Assets/loggo2.png";
//import logo2 from "../Assets/gs del norte logo  360x115.png";
import logo2 from "../Assets/GASdelnortelogo.png";
//import fotogas15 from "../Assets/GAS 15.png";
//import fotogasBu from "../Assets/650X388px WEB gas butano.png";
//import fotogasPla from "../Assets/650X388px WEB autoelevadores.png";
//import fotogasPro from "../Assets/GAS 45.png";
// import logodireccion from "../Assets/logodireccion.png"; // solo lo usan las cards comentadas
import logotelefono from "../Assets/logotelefono.png";
import logowpp from "../Assets/logowpp.png";
// import logodelivery from "../Assets/logodelivery.png"; // solo lo usan las cards comentadas
//import videoSourceGas from "../Assets/Gas del norte web v2.mp4";
import { useTranslation } from "react-i18next";
import NAVBAR from "./NavBarNueva";
import NAVBARMOBILE from "./NavBarMobile";
import "./Gasdelnorte.css";

const Gas = () => {
  // eslint-disable-next-line no-unused-vars
  const [t, i18next] = useTranslation("global");
  const [activeSlide, setActiveSlide] = useState(1);

  const CustomPagination = ({ totalSlides, activeSlide }) => {
    return (
      <div className="custom-pagination">
        {[...Array(totalSlides)].map((_, index) => (
          <div
            key={index}
            className={`pagination-point ${
              index + 1 === activeSlide ? "active" : ""
            }`}
          />
        ))}
      </div>
    );
  };

  const handleSlideChange = (swiper) => {
    setActiveSlide(swiper.activeIndex + 1);
  };

  const [selectedButton, setSelectedButton] = useState(1);

  const handleButtonClick = (buttonNumber) => {
    setSelectedButton(buttonNumber);
  };

  // Cargar el script de Botmaker cuando el componente se monte
  useEffect(() => {
    // Verificar si el script ya existe
    const existingScript = document.querySelector('script[src*="botmaker.com"]');
    
    if (!existingScript) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.async = true;
      script.src = 'https://go.botmaker.com/rest/webchat/p/RH4BBMI8PI/init.js';
      
      // Esperar a que el script se cargue para mostrar el chat
      script.onload = () => {
        // Pequeño delay para asegurar que las funciones de Botmaker estén disponibles
        setTimeout(() => {
          if (typeof window.bmShow === 'function') {
            window.bmShow();
          }
        }, 500);
      };
      
      document.body.appendChild(script);
    } else {
      // Si el script ya existe, mostrar el chat
      setTimeout(() => {
        if (typeof window.bmShow === 'function') {
          window.bmShow();
        }
      }, 100);
    }

    // Ocultar el chatbot cuando el componente se desmonte
    return () => {
      // Ocultar el chatbot usando la función de Botmaker
      if (typeof window.bmHide === 'function') {
        window.bmHide();
      }
      
      // También intentar ocultar el chatbot directamente en el DOM como respaldo
      // Buscar el widget de Botmaker por varios selectores posibles
      const selectors = [
        '[id*="botmaker"]',
        '[class*="botmaker"]',
        '[id*="webchat"]',
        '[class*="webchat"]',
        'iframe[src*="botmaker"]'
      ];
      
      selectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(el => {
          if (el.style) {
            el.style.display = 'none';
          }
        });
      });
    };
  }, []);

  return (
    <div className="home-container">
      <Helmet>
        {/* Título y descripción básicos */}
        <title>© 2025 Gas del Norte Sociedad Anonima</title>
        <meta
          name="description"
          content="Gas del Norte Sociedad Anonima - Es nuestra unidad de negocio encargada del comercio y la distribución exclusiva de gas envasado YPF GAS en la provincia de Salta desde hace veinte años."
        />

        {/* Open Graph / Facebook Meta Tags */}
        <meta property="og:type" content="business.business" />
        <meta property="og:title" content="Gas del Norte Sociedad Anonima" />
        <meta property="og:site_name" content="Gas del Norte Sociedad Anonima" />
        <meta property="og:url" content="https://cn-grupo.com/gasdelnorte/" />
        <meta
          property="og:description"
          content="Distribuidor autorizado YPF Gas. Venta y distribución de gas butano, propano y garrafas en Salta, Argentina."
        />
        <meta property="og:image" content="https://cn-grupo.com/LogoGasdelNorteSA.png" />

        {/* Información del negocio para Meta */}
        <meta
          property="business:contact_data:street_address"
          content="Avda.Chile 175"
        />
        <meta property="business:contact_data:locality" content="Salta" />
        <meta property="business:contact_data:region" content="Salta" />
        <meta property="business:contact_data:postal_code" content="4400" />
        <meta
          property="business:contact_data:country_name"
          content="Argentina"
        />
        <meta property="business:contact_data:cuit" content="30-70823944-1" />
        <meta
          property="business:contact_data:phone_number"
          content="+54 3874236555"
        />
        <meta
          property="business:contact_data:website"
          content="https://cn-grupo.com/gasdelnorte"
        />

        {/* Meta tags adicionales */}
        <meta name="author" content="CN Grupo" />
        <meta name="geo.region" content="AR-A" />
        <meta name="geo.placename" content="Salta" />
        <meta
          name="geo.position"
          content="-65.41651339151728, -24.804615680399422"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Gas del Norte Sociedad Anonima" />
        <meta
          name="twitter:description"
          content="Distribuidor autorizado YPF Gas en Salta"
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://cn-grupo.com/gasdelnorte/" />

        <script type="application/ld+json">
           {JSON.stringify({
             "@context": "https://schema.org",
             "@type": "LocalBusiness",
             "name": "Gas del Norte SA",
             "image": "https://cn-grupo.com/LogoGasdelNorteSA.png",
             "logo": "https://cn-grupo.com/LogoGasdelNorteSA.png",
             "@id": "https://cn-grupo.com/gasdelnorte/",
             "url": "https://cn-grupo.com/gasdelnorte/",
             "telephone": "+54 3874236555",
             "address": {
                "@type": "PostalAddress",
                "streetAddress": "Avda.Chile 1275",
                "addressLocality": "Salta",
                "addressRegion": "Salta",
                "postalCode": "4400",
                "addressCountry": "AR"
            },
            "geo": {
              "@type": "GeoCoordinates",
              "latitude": -24.804615680399422,
              "longitude": -65.41651339151728
            },
            "taxID": "30-70823944-1",
          })}
  </script>
      </Helmet>

      <div className="video">
        <video
          /*src={videoSourceGas}*/
          src="https://webcontent.cn-grupo.net/Media/Gas%20del%20norte%20web%20v2.mp4"
          autoPlay
          loop
          muted
          playsInline
          className="tuvideo"
        ></video>
        <div className="content">
          <div className="BarraEscritorio">
            <NAVBAR></NAVBAR>
          </div>
          <div className="BarraMobile">
            <NAVBARMOBILE></NAVBARMOBILE>
          </div>
          <div className="redes-container-empresa-gas">
            <a
              href="https://www.linkedin.com/company/combustibles-del-norte-sa"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedin className="icono-red-social" />
            </a>
            <a
              href="https://www.instagram.com/gasdelnorteypf/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram className="icono-red-social" />
            </a>
            <a
              href="https://www.facebook.com/gasdelnorte"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebook className="icono-red-social" />
            </a>
          </div>
          <div className="txt-redesGas">
            <div className="txt-container-empresaGas">
              <div className="linea-titulo">
                <div className="badge-nuestra-empresa">
                  <p className="nuestra-empresa">{t("li.OUR BUSINESSES")}</p>
                </div>
              </div>
              <h2
                className={
                  i18next.language === "es" ? "logistica-title" : "logistica-titleEN"
                }
              >
                GAS DEL NORTE
              </h2>
            </div>
          </div>
        </div>
      </div>

      <div className="container-gas">
        <img src={logo2} alt="" className="gasimg1" />
        <p className="p-gas1">
          {" "}
          <span className="txt-empresa-spanGas">{t("txtGas.txt1")}</span>{" "}
          {t("txtGas.txt2")}
          <span className="txt-empresa-spanGas"> {t("txtGas.txt3")}</span>{" "}
          {t("txtGas.txt4")}
          <span className="txt-empresa-spanGas"> {t("txtGas.txt5")} </span>
          {t("txtGas.txt6")}
          <br></br>
          <br></br>
          {t("txtGas.txt7")}
          <span className="txt-empresa-spanGas"> {t("txtGas.txt3")} </span>
          {t("txtGas.txt8")}
          <span className="txt-empresa-spanGas"> {t("txtGas.txt9")}</span>{" "}
          {t("txtGas.txt10")}
          <span className="txt-empresa-spanGas"> {t("txtGas.txt11")} </span>
          {t("txtGas.txt12")}
          <br></br>
          <br></br>
          <span className="txt-empresa-spangGas">{t("txtGas.txt13")}</span>{" "}
          <span className="lineagas"></span>
          <span className="txt-empresa-spangGas">{t("txtGas.txt14")}</span>
          <span className="lineagas"></span>
          <span className="txt-empresa-spangGas">{t("txtGas.txt15")}</span>
        </p>
      </div>
      <div className="banner-gas"></div>

      <div className="container-txt-cardGas">
        <h2 className="gas-title">{t("txtProductosGas.txt1")}</h2>
        <hr className="linea-gas"></hr>
        <p className="txt-gas-boton">
          {t("txtProductosGas.txt2")}{" "}
          <span className="txt-empresa-spanGas">
            {t("txtProductosGas.txt3")}
          </span>{" "}
          {t("txtProductosGas.txt4")}
          <span className="txt-empresa-spanGas">
            {" "}
            {t("txtProductosGas.txt5")}
          </span>{" "}
          {t("txtProductosGas.txt6")}
        </p>
        <div className="gas-buttons">
          <button
            className="info-btn-gas"
            onClick={() => handleButtonClick(1)}
            style={{
              backgroundColor: selectedButton === 1 ? "#009fe3" : "transparent",
              color: selectedButton === 1 ? "white" : "#009fe3",
            }}
          >
            {t("txtButano.txt1")}
          </button>
          <button
            className="info-btn-gas"
            onClick={() => handleButtonClick(2)}
            style={{
              backgroundColor: selectedButton === 2 ? "#009fe3" : "transparent",
              color: selectedButton === 2 ? "white" : "#009fe3",
            }}
          >
            {t("txtPropano.txt1")}
          </button>
          <button
            className="info-btn-gas"
            onClick={() => handleButtonClick(3)}
            style={{
              backgroundColor: selectedButton === 3 ? "#009fe3" : "transparent",
              color: selectedButton === 3 ? "white" : "#009fe3",
            }}
          >
            {t("txtGarrafa15.txt1")}
          </button>
          <button
            className="info-btn-gas"
            onClick={() => handleButtonClick(4)}
            style={{
              backgroundColor: selectedButton === 4 ? "#009fe3" : "transparent",
              color: selectedButton === 4 ? "white" : "#009fe3",
            }}
          >
            {t("txtGarrafa13.txt1")}
          </button>
        </div>
        <div className="card">
          {selectedButton === 1 && (
            <>
              <div className="containerfoto-botones-gas">
                <img
                  src="https://webcontent.cn-grupo.net/Media/Fotos/Gas/650X388px WEB gas butano.png"
                  alt=""
                  className="fotobotonesgas"
                />
                <div className="txt-logos-neca">
                  <h2 className="gas-title2">{t("txtButano.txt2")}</h2>
                  <p className="txt-gas-boton2">
                    {t("txtButano.txt3")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtButano.txt4")}
                    </span>{" "}
                    {t("txtButano.txt5")}
                  </p>
                </div>
              </div>
            </>
          )}
          {selectedButton === 2 && (
            <>
              <div className="containerfoto-botones-gas">
                <img
                  src="https://webcontent.cn-grupo.net/Media/Fotos/Gas/GAS 45.png"
                  alt=""
                  className="fotobotonesgas"
                />
                <div className="txt-logos-neca">
                  <h2 className="gas-title2">{t("txtPropano.txt2")}</h2>
                  <p className="txt-gas-boton2">
                    {t("txtPropano.txt3")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtPropano.txt4")}
                    </span>{" "}
                    {t("txtPropano.txt5")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtPropano.txt6")}{" "}
                    </span>
                    {t("txtPropano.txt7")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtPropano.txt8")}
                    </span>
                  </p>
                </div>
              </div>
            </>
          )}
          {selectedButton === 3 && (
            <>
              <div className="containerfoto-botones-gas">
                <img
                  src="https://webcontent.cn-grupo.net/Media/Fotos/Gas/GAS 15.png"
                  alt=""
                  className="fotobotonesgas"
                />
                <div className="txt-logos-neca">
                  <h2 className="gas-title2">{t("txtGarrafa15.txt2")}</h2>
                  <p className="txt-gas-boton2">
                    {t("txtGarrafa15.txt3")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtGarrafa15.txt4")}
                    </span>{" "}
                    {t("txtGarrafa15.txt5")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtGarrafa15.txt6")}{" "}
                    </span>
                    {t("txtGarrafa15.txt7")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtGarrafa15.txt8")}
                    </span>
                    {t("txtGarrafa15.txt9")}
                  </p>
                </div>
              </div>
            </>
          )}
          {selectedButton === 4 && (
            <>
              <div className="containerfoto-botones-gas">
                <img
                  src="https://webcontent.cn-grupo.net/Media/Fotos/Gas/650X388px WEB autoelevadores.png"
                  alt=""
                  className="fotobotonesgas"
                />
                <div className="txt-logos-neca">
                  <h2 className="gas-title2">{t("txtGarrafa13.txt2")}</h2>
                  <p className="txt-gas-boton2">
                    {t("txtGarrafa13.txt3")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtGarrafa13.txt4")}
                    </span>{" "}
                    {t("txtGarrafa13.txt5")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtGarrafa13.txt6")}{" "}
                    </span>
                    {t("txtGarrafa13.txt7")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtGarrafa13.txt8")}
                    </span>{" "}
                    {t("txtGarrafa13.txt9")}
                  </p>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
      <section className="swiper-containerGas">
        <CustomPagination totalSlides={4} activeSlide={activeSlide} />
        <Swiper
          onSlideChange={handleSlideChange}
          pagination={false}
          slidesPerView={1}
          modules={[Pagination]}
        >
          <SwiperSlide>
            <div className="cardGas">
              <div className="containerfoto-botones-gas">
                <img
                  src="https://webcontent.cn-grupo.net/Media/Fotos/Gas/650X388px WEB gas butano.png"
                  alt=""
                  className="fotobotonesgas"
                />
                <div className="txt-logos-neca">
                  <h2 className="gas-title2">{t("txtButano.txt2")}</h2>
                  <p className="txt-gas-boton2">
                    {t("txtButano.txt3")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtButano.txt4")}
                    </span>{" "}
                    {t("txtButano.txt5")}
                  </p>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="cardGas">
              <div className="containerfoto-botones-gas">
                <img
                  src="https://webcontent.cn-grupo.net/Media/Fotos/Gas/GAS 45.png"
                  alt=""
                  className="fotobotonesgas"
                />
                <div className="txt-logos-neca">
                  <h2 className="gas-title2">{t("txtPropano.txt2")}</h2>
                  <p className="txt-gas-boton2">
                    {t("txtPropano.txt3")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtPropano.txt4")}
                    </span>{" "}
                    {t("txtPropano.txt5")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtPropano.txt6")}{" "}
                    </span>
                    {t("txtPropano.txt7")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtPropano.txt8")}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="cardGas">
              <div className="containerfoto-botones-gas">
                <img
                  src="https://webcontent.cn-grupo.net/Media/Fotos/Gas/GAS 15.png"
                  alt=""
                  className="fotobotonesgas"
                />
                <div className="txt-logos-neca">
                  <h2 className="gas-title2">{t("txtGarrafa15.txt2")}</h2>
                  <p className="txt-gas-boton2">
                    {t("txtGarrafa15.txt3")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtGarrafa15.txt4")}
                    </span>{" "}
                    {t("txtGarrafa15.txt5")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtGarrafa15.txt6")}{" "}
                    </span>
                    {t("txtGarrafa15.txt7")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtGarrafa15.txt8")}
                    </span>
                    {t("txtGarrafa15.txt9")}
                  </p>
                </div>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="cardGas">
              <div className="containerfoto-botones-gas">
                <img
                  src="https://webcontent.cn-grupo.net/Media/Fotos/Gas/650X388px WEB autoelevadores.png"
                  alt=""
                  className="fotobotonesgas"
                />
                <div className="txt-logos-neca">
                  <h2 className="gas-title2">{t("txtGarrafa13.txt2")}</h2>
                  <p className="txt-gas-boton2">
                    {t("txtGarrafa13.txt3")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtGarrafa13.txt4")}
                    </span>{" "}
                    {t("txtGarrafa13.txt5")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtGarrafa13.txt6")}{" "}
                    </span>
                    {t("txtGarrafa13.txt7")}{" "}
                    <span className="txt-empresa-spanGas">
                      {t("txtGarrafa13.txt8")}
                    </span>{" "}
                    {t("txtGarrafa13.txt9")}
                  </p>
                </div>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </section>

      <div className="container-txt-cardGas">
        <h2 className="gas-title">{t("txtContacto.txt1")}</h2>
        <hr className="linea-gas"></hr>
        <p className="txt-gas-card">{t("txtContacto.txt2")}</p>
        <div className="container-cards-gas">
          {/*<div className="card-gas">
            <div className="titulo-gas">
              <h2 className="title-direccion-gas">{t("txtContacto.txt3")}</h2>
              <img src={logodireccion} alt="" className="logogas1" />
            </div>
            <p className="txt-direccion-mollar">
              Avda.Chile 1275 - Salta (4400)
            </p>
          </div>*/}

          <div className="card-gas">
            <div className="titulo-gas">
              <h2 className="title-direccion-gas">{t("txtContacto.txt4")}</h2>
              <img
                src={logotelefono}
                alt=""
                className={
                  i18next.language === "es" ? "logogas2" : "logogas2EN"
                }
              />
            </div>
            <p className="txt-direccion-mollar">0800-122-5800</p>
          </div>

          <div className="card-gas">
            <div className="titulo-gas">
              <h2 className="title-direccion-gas">WhatsApp</h2>{" "}
              <img src={logowpp} alt="" className="logogas3" />
            </div>
            <p className="txt-direccion-mollar">387-4688288</p>
          </div>

          {/*<div className="card-gas">
            <div className="titulo-gas">
              <h2 className="title-direccion-gas">{t("txtContacto.txt6")}</h2>
              <img src={logodelivery} alt="" className="logogas4" />
            </div>
            <p className="txt-direccion-mollar">Gas del Norte - YPF Gas</p>
          </div>*/}
        </div>
      </div>
      <div className="footer">
            <div className="footer-left">
              <p className="txt-foo">{t("txt-foo2.Footer1")}</p>
            </div>
            <div className="footer-right">
              <div className="footer-right-left">
                <a 
                  href="https://webcontent.cn-grupo.net/Assets/Politica/CN-GRUPO_ Política de privacidad.pdf" 
                  target="_blank"
                  rel="noopener noreferrer"
                  className="txt-foo-politicas"
                  style={{ textDecoration: 'none', color: 'inherit' }}
                >
                  Politicas de privacidad
                </a>
              </div>
              <div className="footer-right-right">
                <p className="txt-foo2">{t("txt-foo2.Footer", { year: new Date().getFullYear() })}</p>
              </div>
            </div>
          </div>
    </div>
  );
};

export default Gas;
